'use client';

import React, { useEffect, useRef } from 'react';
import { getColorVar } from 'src/utils/theme/colorVars';

export default function ActiveDot({
	x,
	y,
	stroke,
	className,
}: {
	x: number;
	y: number;
	stroke: string;
	className?: string;
}) {
	const circleRef = useRef(null);

	useEffect(() => {
		if (circleRef.current) {
			(circleRef.current as HTMLElement).style.transform = 'scale(1)';
		}
	}, []);

	const dotSize = 10;
	const dotRadius = dotSize / 2;
	const borderWidth = 1;

	return (
		<svg
			x={x - dotRadius}
			y={y - dotRadius}
			width={dotSize}
			height={dotSize}
			viewBox={`0 0 ${dotSize} ${dotSize}`}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<circle
				ref={circleRef}
				cx={dotRadius}
				cy={dotRadius}
				r={dotRadius - borderWidth}
				fill={stroke}
				stroke={getColorVar('main-bg')}
				strokeWidth={borderWidth}
			/>
		</svg>
	);
}
